import { useLocation } from '@xing-com/crate-core-router';
import { UpsellFrame } from '@xing-com/crate-upsell-frame';
import { useFeature, useLoginState } from '@xing-com/hub';

import { CampaignPageLoggedIn } from './pages/campaign-page-logged-in';
import { CampaignPageLoggedOut } from './pages/campaign-page-logged-out';
import { CampaignPagePreview } from './pages/campaign-page-preview';

export const MainPage: React.FC = () => {
  const isLoggedOut = useLoginState() === 'LOGGED_OUT';
  const isAdminURL = useLocation().pathname.includes('/admin/campaign-preview');
  const isXingEmployee = useFeature('isXingEmployee');
  const isAdminPreview = !!(isAdminURL && isXingEmployee);

  return (
    <UpsellFrame>
      {isAdminPreview ? (
        <CampaignPagePreview />
      ) : isLoggedOut ? (
        <CampaignPageLoggedOut />
      ) : (
        <CampaignPageLoggedIn />
      )}
    </UpsellFrame>
  );
};
